
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/college-luggage-storage-solutions",
      function () {
        return require("private-next-pages/college-luggage-storage-solutions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/college-luggage-storage-solutions"])
      });
    }
  